import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { signup } from "@/api/auth";
import { Button, Input } from "@/components";
import { useLang } from "@/i18n/LanguageContext";

export function SignupPage() {
  const { t } = useLang();
  const [orgName, setOrgName] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await signup(orgName, email, fullName || null);
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : t("Aanmaken mislukt", "Could not sign up"));
    } finally {
      setBusy(false);
    }
  }

  if (done) {
    return (
      <div className="center-col">
        <p className="eyebrow">{t("Account aanmaken", "Create account")}</p>
        <h1 style={{ marginBottom: 8 }}>{t("Controleer je inbox", "Check your inbox")}</h1>
        <p style={{ color: "var(--grey-text)", marginBottom: 24 }}>
          {t(
            "We hebben een e-mail gestuurd om je account te activeren en een wachtwoord in te stellen. Daarna kun je inloggen.",
            "We've sent an e-mail to activate your account and set a password. After that you can log in.",
          )}
        </p>
        <Link to="/login" className="btn btn-outline">{t("Naar inloggen", "Go to log in")}</Link>
      </div>
    );
  }

  return (
    <div className="center-col">
      <p className="eyebrow">{t("Account aanmaken", "Create account")}</p>
      <h1 style={{ marginBottom: 8 }}>{t("Start een proefperiode", "Start a free trial")}</h1>
      <p style={{ color: "var(--grey-text)", marginBottom: 24 }}>
        {t("Maak een organisatie aan; je wordt org-beheerder.", "Create an organisation; you'll become its administrator.")}
      </p>
      <form onSubmit={onSubmit}>
        {error && <div className="form-error">{error}</div>}
        <Input label={t("Organisatienaam", "Organisation name")} name="org" required value={orgName} onChange={(e) => setOrgName(e.target.value)} />
        <Input label={t("Jouw naam", "Your name")} name="name" autoComplete="name" value={fullName} onChange={(e) => setFullName(e.target.value)} />
        <Input label={t("Werk-e-mail", "Work e-mail")} name="email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />
        <Button type="submit" disabled={busy}>{busy ? t("Bezig…", "Working…") : t("Account aanmaken", "Create account")}</Button>
      </form>
      <p style={{ marginTop: 18, fontSize: 13, color: "var(--grey-text)" }}>
        {t("Door verder te gaan ga je akkoord met onze ", "By continuing you agree to our ")}
        <Link to="/privacy" className="eyebrow" style={{ display: "inline" }}>{t("privacyverklaring", "privacy statement")}</Link>.
      </p>
      <p style={{ marginTop: 10 }}>
        <Link to="/login" className="eyebrow">{t("← Al een account? Inloggen", "← Already have an account? Log in")}</Link>
      </p>
    </div>
  );
}
